import React, { forwardRef } from 'react';

const PageHeader = forwardRef(({
    kicker,
    title,
    subtitle,
    description,
    actions,
    badge,
    breadcrumbs,
    className = '',
    style,
    ...props
}, ref) => {
    const finalSubtitle = subtitle || description;

    return (
        <header
            ref={ref}
            className={className}
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                paddingBottom: '1.25rem',
                marginBottom: '1.5rem',
                borderBottom: '1px solid var(--border)',
                boxSizing: 'border-box',
                fontFamily: 'var(--font-ui)',
                ...style
            }}
            {...props}
        >
            {breadcrumbs && (
                <div style={{ fontSize: '0.8125rem', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>
                    {breadcrumbs}
                </div>
            )}

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', maxWidth: '48rem' }}>
                    {kicker && (
                        <span
                            style={{
                                fontSize: '0.75rem',
                                fontWeight: '600',
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em',
                                color: 'var(--accent-ink)'
                            }}
                        >
                            {kicker}
                        </span>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                        <h1
                            style={{
                                margin: 0,
                                fontSize: '1.875rem',
                                fontWeight: '400',
                                lineHeight: '1.2',
                                color: 'var(--text)',
                                fontFamily: 'var(--font-display)'
                            }}
                        >
                            {title}
                        </h1>
                        {badge}
                    </div>

                    {finalSubtitle && (
                        <p
                            style={{
                                margin: '0.25rem 0 0',
                                fontSize: '0.875rem',
                                lineHeight: '1.4',
                                color: 'var(--text-muted)'
                            }}
                        >
                            {finalSubtitle}
                        </p>
                    )}
                </div>

                {actions && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                        {actions}
                    </div>
                )}
            </div>
        </header>
    );
});

PageHeader.displayName = 'PageHeader';

export { PageHeader };
export default PageHeader;
